<template>
  <layout-main-inner title="下属公司">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增下属公司
      </el-button>
    </div>
    <layout-card-wrap>
      <!-- <template slot="form">
        <el-input
          v-model="config.quarantineName"
          clearable
          placeholder="请输入分类名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template> -->
      <el-table
        border
        :data="list">
        <el-table-column
          label="机构名称"
          prop="sgsName">
        </el-table-column>
        <el-table-column
          label="机构账号"
          width="80"
          prop="adminAccount">
        </el-table-column>
        <el-table-column
          label="机构地址"
          width="240">
          <template slot-scope="{ row }">
            {{ row.serviceProvinceName }}-{{ row.serviceCityName }}-{{ row.sgsAddress }}
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          width="100"
          prop="sgsPerson">
        </el-table-column>
        <el-table-column
          label="联系电话"
          width="130"
          prop="sgsPhone">
        </el-table-column>
        <el-table-column
          label="邮箱"
          width="160"
          prop="sgsEmail">
        </el-table-column>
        <el-table-column
          label="操作"
          width="150">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-sgs-modal
      ref="category"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditSgsModal from './edit-sgs-modal.vue'

export default {
  name: 'SgsIndex',
  components: { EditSgsModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.category.update({
        parentSgsId: row.parentSgsId,
        sgsId: row.sgsId,
        adminAccount: row.adminAccount,
        sgsName: row.sgsName,
        sgsPerson: row.sgsPerson,
        sgsPhone: row.sgsPhone,
        sgsEmail: row.sgsEmail,
        area: [row.serviceProvinceCode, row.serviceCityCode],
        sgsAddress: row.sgsAddress
      })
    },
    additem() {
      this.$refs.category.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该下属公司?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletesgs', {
          payload: {
            sgsId: row.sgsId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getsgslist', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
